import { render, staticRenderFns } from "./timelog-chart-tabs.vue?vue&type=template&id=bf89afc4&scoped=true&"
import script from "./timelog-chart-tabs.vue?vue&type=script&lang=js&"
export * from "./timelog-chart-tabs.vue?vue&type=script&lang=js&"
import style0 from "./timelog-chart-tabs.vue?vue&type=style&index=0&id=bf89afc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf89afc4",
  null
  
)

export default component.exports